import FollowUpFormTab from "./followupFormTab";
export default FollowUpFormTab;